import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { recommendationDbActiveDataSelector } from "./recommendationDbActiveDataSelector";

export const recommendationDbDataLengthSelector = createDraftSafeSelector(
  [recommendationDbActiveDataSelector],
  (data) => data?.length ?? 0,
);
